<template>
    <el-select v-model="userInfoRef.speed" :size="null == domSize ? '' : 'large'">
        <el-option
                :key="'slowMoveSpeedOption'"
                :label="i18n.tkey('lang_slow')"
                :value="0.12"
        />

        <el-option
                :key="'normalMoveSpeedOption'"
                :label="i18n.tkey('lang_normal')"
                :value="0.24"
        />

        <el-option
                :key="'fastMoveSpeedOption'"
                :label="i18n.tkey('lang_fast')"
                :value="0.36"
        />

        <el-option
                :key="'fast2MoveSpeedOption'"
                :label="i18n.tkey('lang_fast_2')"
                :value="0.72"
        />

    </el-select>
</template>

<script setup>
    import {inject, ref, toRef} from "vue";
    import {useUserinfo} from "@/stores/userinfo";

    const userInfoRef = toRef(useUserinfo())

    const props = defineProps(["domSize"])

    const i18n = inject("i18n")

</script>

<style scoped>

</style>